(function() { window.GUID_87f04cf4_059b_4101_8653_70d776235264 = { getGuid: function() { return "87f04cf4-059b-4101-8653-70d776235264"; } }; })();
$(function () {
    var btnForceStopPrintQueue = $('#BtnForceStopPrintQueue');
    btnForceStopPrintQueue.off('click');
    var btnForceStartPrintQueue = $('#BtnForceStartPrintQueue');
    btnForceStartPrintQueue.off('click');
    var btnForceUpgrade = $('#BtnForceUpgrade');
    btnForceUpgrade.off('click');
    var btnIdentifyWpfInstance = $('#BtnIdentifyWpfInstance');
    btnIdentifyWpfInstance.off('click');
    let gridViewPrinterQueuesUI = $('#GridViewPrinterQueues');
    let gridViewPrinterQueues = gridViewPrinterQueuesUI.data('context');
    CS.body.on('Refreshed', '#GridViewPrinterQueues', function (e, gridView) {
        gridViewPrinterQueues = gridView;
    });
    if (!(typeof gridViewPrinterQueues === "undefined")) {
        gridViewPrinterQueues.SelectionChange = function () {
            if (this.SelectedRows.length > 0) {
                btnForceStartPrintQueue.removeClass('IsDisabled');
                btnForceStopPrintQueue.removeClass('IsDisabled');
                btnForceUpgrade.removeClass('IsDisabled');
                if (this.SelectedRows.length == 1) {
                    btnIdentifyWpfInstance.removeClass('IsDisabled');
                }
                else {
                    btnIdentifyWpfInstance.addClass('IsDisabled');
                }
            }
            else {
                btnForceStopPrintQueue.addClass('IsDisabled');
                btnForceStartPrintQueue.addClass('IsDisabled');
                btnForceUpgrade.addClass('IsDisabled');
                btnIdentifyWpfInstance.addClass('IsDisabled');
            }
        };
    }
    if (btnForceUpgrade != null) {
        btnForceUpgrade.on('click', 'a', function (e) {
            e.preventDefault();
            var data = {
                printerQueueIds: gridViewPrinterQueues.GetSelectedRowIds()
            };
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "",
                Url: CSParameters.RUrl + 'PrinterQueues/ForceUpgradePrinterQueue/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
            });
            popup.OnPosted = function (response) {
                gridViewPrinterQueues.UpdateRowsFromPost(response);
            };
            /*
            ShowFormPopup(CSParameters.RUrl + 'PrinterQueues/ForceUpgradePrinterQueue/' + CSParameters.SportEventId, data, gridViewPrinterQueues, function () {
                $(this).dialog("close");
            });
            */
        });
    }
    if (btnForceStopPrintQueue != null) {
        btnForceStopPrintQueue.on('click', 'a', function (e) {
            e.preventDefault();
            CompuSport.Ajax.Post(CSParameters.RUrl + "PrinterQueues/ForceStopPrintQueue/" + CSParameters.SportEventId, { printerQueueIds: gridViewPrinterQueues.GetSelectedRowIds() }, function (queryResult) {
                gridViewPrinterQueues.UpdateRowsFromPost(queryResult);
            });
        });
    }
    if (btnForceStartPrintQueue != null) {
        btnForceStartPrintQueue.on('click', 'a', function (e) {
            e.preventDefault();
            var data = {
                printerQueueIds: gridViewPrinterQueues.GetSelectedRowIds()
            };
            let popup = new CompuSport.Controls.Popup();
            popup.GetAndShow({
                PopupId: "",
                Url: CSParameters.RUrl + 'PrinterQueues/ForceStartPrinterQueue/' + CSParameters.SportEventId,
                Data: data,
                AjaxCallType: CompuSport.Ajax.AjaxCallType.POST
            });
            popup.OnPosted = function (response) {
                gridViewPrinterQueues.UpdateRowsFromPost(response);
            };
            /*
            ShowFormPopup(CSParameters.RUrl + 'PrinterQueues/ForceStartPrinterQueue/' + CSParameters.SportEventId, data, gridViewPrinterQueues, function () {
                $(this).dialog("close");
            });
            */
        });
    }
    if (btnIdentifyWpfInstance != null) {
        btnIdentifyWpfInstance.on('click', 'a', function (e) {
            e.preventDefault();
            CompuSport.Ajax.Post(CSParameters.RUrl + "PrinterQueues/IdentifyWpfInstance/" + CSParameters.SportEventId, { printerQueueId: gridViewPrinterQueues.GetSelectedRowIds() }, function (queryResult) {
                gridViewPrinterQueues.UpdateRowsFromPost(queryResult);
            });
        });
    }
});

//# sourceMappingURL=PrinterQueues.js.map
